import { render, staticRenderFns } from "./OptionPortClient.vue?vue&type=template&id=264879c2&scoped=true&"
import script from "./OptionPortClient.vue?vue&type=script&lang=ts&"
export * from "./OptionPortClient.vue?vue&type=script&lang=ts&"
import style0 from "./OptionPortClient.vue?vue&type=style&index=0&id=264879c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264879c2",
  null
  
)

export default component.exports